module.exports = __webpack_public_path__ + "static/media/click-custom-fields.3807c791.png";